import { useContext, useEffect } from 'react';
import { SplitContext, useTreatments } from '@splitsoftware/splitio-react';

import { trackExperimentAssignment } from 'utils/analyticsUtils';

import { FEATURE_FLAG_NAMES, FEATURE_FLAG_ON_VALUE } from './constants';

/**
 * This hook takes a feature flag name and checks through Split to fetch the
 * value for the current user. The return is an object that contains loading
 * and error flags, as well as the value of the feature flag. This is only
 * intended for use with feature flags with an "enabled" response of `on`, with
 * all other responses disabling the flag.
 *
 * @param {string} flagName The name of the feature flag in Split
 * @returns {splitIsReady, splitTimedOut, value}
 */
export function useSplitOnOffFeatureFlag(flagName) {
    const { isReady: splitIsReady, isTimedout: splitTimedOut } = useContext(SplitContext);
    const treatment = useTreatments([flagName])[flagName]?.treatment;

    const splitLoadedCorrectly = splitIsReady && !splitTimedOut;

    useEffect(() => {
        if (!splitLoadedCorrectly) return;

        if (flagName === FEATURE_FLAG_NAMES.PLUS_MEMBERSHIP) {
            return;
        }

        trackExperimentAssignment({
            experiment: flagName,
            variation: treatment,
            trackEvent: true,
        });
    }, [splitLoadedCorrectly, flagName, treatment]);

    return {
        splitIsReady,
        splitTimedOut,
        value: treatment === FEATURE_FLAG_ON_VALUE,
    };
}
